import React from 'react';
import { TextVariant } from '@naf/text';
import { Button } from '@naf-simba/elements-buttons';
import { CenterProducts, DisplayStyle } from '@appTypes/centerArticleType';
import { useTrackCTA } from '@utils/Tracking/CtaClick/TrackCtaClick';
import S from '../NafProductArticle.styles';

export const StandardProductBlock = ({ product }: { product: CenterProducts }) => {
  const trackCTA = useTrackCTA();

  return (
    <S.ProductCol s="12" m="12" l="8" xl="8">
      {product.memberPrice && (
        <S.TextWrapper>
          <S.InlineText variant={TextVariant.Header2}>
            Medlemspris: {product.memberPrice.campaignPrice || product.memberPrice.price},-
          </S.InlineText>
          {product.memberPrice.campaignPrice && (
            <S.InlineText variant={TextVariant.SubHeader}>{` (Før: ${product.memberPrice.price},-)`}</S.InlineText>
          )}
        </S.TextWrapper>
      )}
      {product.nonMemberPrice && (
        <S.TextWrapper>
          <S.InlineText variant={TextVariant.SubHeader}>
            Ikke medlem: {product.nonMemberPrice.campaignPrice || product.nonMemberPrice.price},-
          </S.InlineText>
          {product.nonMemberPrice.campaignPrice && (
            <S.InlineText variant={TextVariant.SubHeader}>{` (Før: ${product.nonMemberPrice.price},-)`}</S.InlineText>
          )}
        </S.TextWrapper>
      )}
      {product.booking && product.booking.data.href && product.booking.type === 'externalLink' && (
        <Button
          href={product.booking.data.href}
          onClick={() =>
            product?.booking?.data.href &&
            trackCTA({
              cta_position: 'content',
              text: 'Finn ledig tid',
              url: product.booking.data.href,
              cta_hostname: new URL(product.booking.data.href).hostname,
            })
          }
          color={product.displayStyle === DisplayStyle.WithPricePrimaryButton ? 'primary' : 'secondary'}
          target={product.booking.data.blank ? '_blank' : '_self'}
        >
          Finn ledig tid
        </Button>
      )}
    </S.ProductCol>
  );
};
